// extracted by mini-css-extract-plugin
export default {"layout":"A2LnIIpk3NxJotR3OaL_","layoutLight":"jVjeGtHxQ2eLDvFCdyRS","bannerNotificationContainer":"SuPrqOEQIBXkiVXhlqG6","mobileHeaderLogo":"P6VWX8c8ruUOGIb2EoAa"};